module.exports = __webpack_public_path__ + "static/media/Tumbleweed_bg.166f37a7.jpg";